// Local imports
import * as event from '../../datalayer/event.js';
import * as gtm_push from '../../datalayer/gtm/gtm_push.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'gccat_datalayer';

export let global_vars = {};

// ===========================================================================
// gccat-cards card click datalayer
// ===========================================================================

function init_clickhandler(global) {
    let qry = 'div.card.card--imageCard.card--imageCardTop.collection--product';
    let all_card = global.document.querySelectorAll(qry);
    for (let card of all_card) {
        card.addEventListener('click', event => {
            let utag_data = global.utag_data;
            let cur_card = event.currentTarget;

            let data_id = `#${cur_card.attributes.id.value}_data`;
            let card_data = cur_card.querySelector(data_id);
            let ispromo = card_data.dataset.ispromo;
            let func = ispromo === 'true' ? onclick_promo : onclick_card;
            func(global, utag_data, card_data);
        });
    }
}

function init_category_clickhandler(global) {
    let qry = '#gc-nav-category-list li a';
    let all_category_items = global.document.querySelectorAll(qry);
    for (let cat of all_category_items) {
        cat.addEventListener('click', () => {
            let href = cat.attributes.href.value;
            onclick_cat(global, href);
        });
    }
}

function onclick_cat(global, href) {
    let all_tabbed = global.document.querySelectorAll(
        `${href} div.card--tabbedproduct`
    );

    // Iterate through the cards and push data to object
    for (let card of all_tabbed) {
        let cardnum = card.dataset.cardnum;
        let data_store = card.querySelector(`#dataid${cardnum}`);
        let dataset = data_store.dataset;

        global.productImpressions.push({
            item_name: dataset.name,
            item_id: dataset.id,
            price: dataset.price,
            item_category: dataset.category,
            item_variant: dataset.variant,
            item_list_name: 'Gift Catalogue Products List',
            index: cardnum,
        });

        global.uaProductImpressions.push({
            name: dataset.productname,
            id: dataset.productid,
            price: dataset.price,
            category: dataset.productcategory,
            variant: dataset.productvariant,
            list: dataset.productlist,
            position: dataset.position,
        });
    }
    gtm_push.push_product_impressions(global);
}

function onclick_promo(global, utag_data, card) {
    let promo_data = card.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Promo Click';
    utag_data['event_label'] = 'OGC Promo Impression Clicked';

    utag_data['promo_ids'] = promo_data.productid;
    utag_data['promo_names'] = promo_data.productname;
    utag_data['promo_creatives'] = promo_data.productcreative;
    utag_data['promo_positions'] = promo_data.position;

    event.dispatch(global, event.EventKind.PromoClick);
}

function onclick_card(global, utag_data, card) {
    let cardnum = card.dataset.cardnum;

    let dataid = `dataid${cardnum}`;
    let data_store = card.querySelector(`#${dataid}`);
    let dataset = data_store.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Product Click';
    utag_data['event_label'] = 'Featured Product Card Clicked';

    utag_data['product_price'] = dataset.price;
    utag_data['product_id'] = dataset.id;
    utag_data['product_name'] = dataset.name;
    utag_data['product_brand'] = dataset.brand;
    utag_data['product_variant'] = dataset.variant;
    utag_data['product_category'] = dataset.category;
    utag_data['product_quantity'] = '1';
    utag_data['product_list'] =
        'Gift Collection Collection Page Featured Gifts';
    utag_data['product_position'] = cardnum;
    utag_data['enh_action'] = 'click';

    //== gtm-push: Featured Gift Card clicked ==//
    let data_object = {
        event: 'select_item',
        ecommerce: {
            items: [
                {
                    item_name: dataset.name,
                    item_id: dataset.id,
                    price: dataset.price,
                    item_category: dataset.category,
                    item_variant: dataset.variant,
                    item_list_name: 'Gift Catalogue Products List',
                    index: cardnum,
                },
            ],
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.ProductClick);
}

// Stores the data for each product card into the global.productImpressions
// object, that originates from gtm_vars.js
function store_product_impressions(global) {
    let qry = 'div.card.card--imageCard.card--imageCardTop.collection--product';
    let all_card = global.document.querySelectorAll(qry);
    for (let card of all_card) {
        let data_id = `#${card.id}_data`;
        let card_data = card.querySelector(data_id);

        global.productImpressions.push({
            item_name: card_data.dataset.productname,
            item_id: card_data.dataset.productid,
            price: card_data.dataset.price,
            item_category: card_data.dataset.productcategory,
            item_variant: card_data.dataset.productvariant,
            item_list_name: 'Gift Catalogue Products List',
            index: card_data.dataset.position,
        });

        global.uaProductImpressions.push({
            name: card_data.dataset.productname,
            id: card_data.dataset.productid,
            price: card_data.dataset.price,
            category: card_data.dataset.productcategory,
            variant: card_data.dataset.productvariant,
            list: card_data.dataset.productlist,
            position: card_data.dataset.position,
        });
    }
}

// Initialize module
export function initialize(global) {
    init_clickhandler(global);
    store_product_impressions(global);
    init_category_clickhandler(global);
}
